import { render } from "./FullscreenLoader.vue?vue&type=template&id=0f6b2865&scoped=true&ts=true"
import script from "./FullscreenLoader.vue?vue&type=script&lang=ts"
export * from "./FullscreenLoader.vue?vue&type=script&lang=ts"

import "./FullscreenLoader.vue?vue&type=style&index=0&id=0f6b2865&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6b2865"]])

export default __exports__